export default __webpack_public_path__ + "static/media/email.cee31251.svg";